/**
 * @packageDocumentation
 * @module HackerAPI.Email.Trigger
 */
import { __extends } from "tslib";
import Base from "../../base/base";
import Record from "./record/record";
/**
 * Data container for mail triggers
 * @class
 * @extends { HackerAPI.Base }
 */
var Trigger = /** @class */ (function (_super) {
    __extends(Trigger, _super);
    /**
     * Creates a new instance
     * @constructor
     * @param mailTrigger
     */
    function Trigger(_a) {
        var _b = _a === void 0 ? {} : _a, trigger_type = _b.trigger_type, triggerType = _b.triggerType, record_id = _b.record_id, recordId = _b.recordId, record_type = _b.record_type, recordType = _b.recordType;
        var _this = _super.call(this) || this;
        /**
         * One of the static strings
         * @type { string }
         */
        _this.triggerType = trigger_type || triggerType;
        /**
         * @type { number }
         */
        _this.recordId = record_id || recordId;
        /**
         * @type { HackerAPI.Email.Trigger.Record }
         */
        _this.recordType = record_type || recordType;
        return _this;
    }
    Object.defineProperty(Trigger, "ON_MAILING_LIST_SIGNUP", {
        /**
         * Trigger type for mailing list signups
         * @returns
         */
        get: function () {
            return "on_mailing_list_signup";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_CLAIM_CREATE", {
        /**
         * Trigger type for claim creation
         * @returns
         */
        get: function () {
            return "on_claim_create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_CLAIM_UPDATE", {
        /**
         * Trigger type for claim update
         * @returns
         */
        get: function () {
            return "on_claim_update";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_CLAIM_DELETE", {
        /**
         * Trigger type for claim delete
         * @returns
         */
        get: function () {
            return "on_claim_delete";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_EMAIL_UPDATE", {
        /**
         * Trigger type for email update
         * @returns
         */
        get: function () {
            return "on_email_update";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_FILE_CREATE", {
        /**
         * Trigger type for file creation
         * @returns
         */
        get: function () {
            return "on_file_create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_USER_CREATE", {
        /**
         * Trigger type for user creation
         * @returns
         */
        get: function () {
            return "on_user_create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_USER_UPDATE", {
        /**
         * Trigger type for user update
         * @returns
         */
        get: function () {
            return "on_user_update";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "ON_USER_DELETE", {
        /**
         * Trigger type for user deletion
         * @returns
         */
        get: function () {
            return "on_user_delete";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Trigger, "Record", {
        /**
         * @returns
         */
        get: function () {
            return Record;
        },
        enumerable: true,
        configurable: true
    });
    return Trigger;
}(Base));
export default Trigger;
//# sourceMappingURL=trigger.js.map